import { render, staticRenderFns } from "./VaButton.vue?vue&type=template&id=1b363434&"
import script from "./VaButton.vue?vue&type=script&lang=js&"
export * from "./VaButton.vue?vue&type=script&lang=js&"
import style0 from "./VaButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports